"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpaMetadata = void 0;
const composer_template_1 = require("../../common/composer_template");
const composer_background_1 = require("../../common/composer_background");
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const wrappers_1 = require("../../../google/protobuf/wrappers");
function createBaseDpaMetadata() {
    return {
        layout: 0,
        templateName: undefined,
        aspectRatio: undefined,
        isFallbackAspectRatio: undefined,
        numImagesShown: undefined,
        template: undefined,
        background: undefined,
    };
}
exports.DpaMetadata = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.layout !== 0) {
            writer.uint32(8).int32(message.layout);
        }
        if (message.templateName !== undefined) {
            wrappers_1.StringValue.encode({ value: message.templateName }, writer.uint32(18).fork()).ldelim();
        }
        if (message.aspectRatio !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.aspectRatio }, writer.uint32(26).fork()).ldelim();
        }
        if (message.isFallbackAspectRatio !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.isFallbackAspectRatio }, writer.uint32(34).fork()).ldelim();
        }
        if (message.numImagesShown !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.numImagesShown }, writer.uint32(42).fork()).ldelim();
        }
        if (message.template?.$case === "fillWidth") {
            composer_template_1.FillWidth.encode(message.template.fillWidth, writer.uint32(50).fork()).ldelim();
        }
        if (message.template?.$case === "fillHeight") {
            composer_template_1.FillHeight.encode(message.template.fillHeight, writer.uint32(58).fork()).ldelim();
        }
        if (message.template?.$case === "fit") {
            composer_template_1.Fit.encode(message.template.fit, writer.uint32(66).fork()).ldelim();
        }
        if (message.template?.$case === "header") {
            composer_template_1.Header.encode(message.template.header, writer.uint32(74).fork()).ldelim();
        }
        if (message.template?.$case === "tilt") {
            composer_template_1.Tilt.encode(message.template.tilt, writer.uint32(82).fork()).ldelim();
        }
        if (message.template?.$case === "carousel") {
            composer_template_1.Carousel.encode(message.template.carousel, writer.uint32(90).fork()).ldelim();
        }
        if (message.template?.$case === "slideshow") {
            composer_template_1.Slideshow.encode(message.template.slideshow, writer.uint32(98).fork()).ldelim();
        }
        if (message.template?.$case === "echoTall") {
            composer_template_1.EchoTall.encode(message.template.echoTall, writer.uint32(106).fork()).ldelim();
        }
        if (message.template?.$case === "echoWide") {
            composer_template_1.EchoWide.encode(message.template.echoWide, writer.uint32(114).fork()).ldelim();
        }
        if (message.template?.$case === "presetColor") {
            composer_template_1.PresetColor.encode(message.template.presetColor, writer.uint32(122).fork()).ldelim();
        }
        if (message.template?.$case === "whiteTall") {
            composer_template_1.WhiteTall.encode(message.template.whiteTall, writer.uint32(130).fork()).ldelim();
        }
        if (message.template?.$case === "whiteWide") {
            composer_template_1.WhiteWide.encode(message.template.whiteWide, writer.uint32(138).fork()).ldelim();
        }
        if (message.background?.$case === "colorBackground") {
            composer_background_1.ColorBackground.encode(message.background.colorBackground, writer.uint32(146).fork()).ldelim();
        }
        if (message.background?.$case === "echoBackground") {
            composer_background_1.EchoBackground.encode(message.background.echoBackground, writer.uint32(154).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDpaMetadata();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.layout = reader.int32();
                    break;
                case 2:
                    message.templateName = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                case 3:
                    message.aspectRatio = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                case 4:
                    message.isFallbackAspectRatio = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 5:
                    message.numImagesShown = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 6:
                    message.template = {
                        $case: "fillWidth",
                        fillWidth: composer_template_1.FillWidth.decode(reader, reader.uint32()),
                    };
                    break;
                case 7:
                    message.template = {
                        $case: "fillHeight",
                        fillHeight: composer_template_1.FillHeight.decode(reader, reader.uint32()),
                    };
                    break;
                case 8:
                    message.template = {
                        $case: "fit",
                        fit: composer_template_1.Fit.decode(reader, reader.uint32()),
                    };
                    break;
                case 9:
                    message.template = {
                        $case: "header",
                        header: composer_template_1.Header.decode(reader, reader.uint32()),
                    };
                    break;
                case 10:
                    message.template = {
                        $case: "tilt",
                        tilt: composer_template_1.Tilt.decode(reader, reader.uint32()),
                    };
                    break;
                case 11:
                    message.template = {
                        $case: "carousel",
                        carousel: composer_template_1.Carousel.decode(reader, reader.uint32()),
                    };
                    break;
                case 12:
                    message.template = {
                        $case: "slideshow",
                        slideshow: composer_template_1.Slideshow.decode(reader, reader.uint32()),
                    };
                    break;
                case 13:
                    message.template = {
                        $case: "echoTall",
                        echoTall: composer_template_1.EchoTall.decode(reader, reader.uint32()),
                    };
                    break;
                case 14:
                    message.template = {
                        $case: "echoWide",
                        echoWide: composer_template_1.EchoWide.decode(reader, reader.uint32()),
                    };
                    break;
                case 15:
                    message.template = {
                        $case: "presetColor",
                        presetColor: composer_template_1.PresetColor.decode(reader, reader.uint32()),
                    };
                    break;
                case 16:
                    message.template = {
                        $case: "whiteTall",
                        whiteTall: composer_template_1.WhiteTall.decode(reader, reader.uint32()),
                    };
                    break;
                case 17:
                    message.template = {
                        $case: "whiteWide",
                        whiteWide: composer_template_1.WhiteWide.decode(reader, reader.uint32()),
                    };
                    break;
                case 18:
                    message.background = {
                        $case: "colorBackground",
                        colorBackground: composer_background_1.ColorBackground.decode(reader, reader.uint32()),
                    };
                    break;
                case 19:
                    message.background = {
                        $case: "echoBackground",
                        echoBackground: composer_background_1.EchoBackground.decode(reader, reader.uint32()),
                    };
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseDpaMetadata();
        message.layout = object.layout ?? 0;
        message.templateName = object.templateName ?? undefined;
        message.aspectRatio = object.aspectRatio ?? undefined;
        message.isFallbackAspectRatio = object.isFallbackAspectRatio ?? undefined;
        message.numImagesShown = object.numImagesShown ?? undefined;
        if (object.template?.$case === "fillWidth" &&
            object.template?.fillWidth !== undefined &&
            object.template?.fillWidth !== null) {
            message.template = {
                $case: "fillWidth",
                fillWidth: composer_template_1.FillWidth.fromPartial(object.template.fillWidth),
            };
        }
        if (object.template?.$case === "fillHeight" &&
            object.template?.fillHeight !== undefined &&
            object.template?.fillHeight !== null) {
            message.template = {
                $case: "fillHeight",
                fillHeight: composer_template_1.FillHeight.fromPartial(object.template.fillHeight),
            };
        }
        if (object.template?.$case === "fit" &&
            object.template?.fit !== undefined &&
            object.template?.fit !== null) {
            message.template = {
                $case: "fit",
                fit: composer_template_1.Fit.fromPartial(object.template.fit),
            };
        }
        if (object.template?.$case === "header" &&
            object.template?.header !== undefined &&
            object.template?.header !== null) {
            message.template = {
                $case: "header",
                header: composer_template_1.Header.fromPartial(object.template.header),
            };
        }
        if (object.template?.$case === "tilt" &&
            object.template?.tilt !== undefined &&
            object.template?.tilt !== null) {
            message.template = {
                $case: "tilt",
                tilt: composer_template_1.Tilt.fromPartial(object.template.tilt),
            };
        }
        if (object.template?.$case === "carousel" &&
            object.template?.carousel !== undefined &&
            object.template?.carousel !== null) {
            message.template = {
                $case: "carousel",
                carousel: composer_template_1.Carousel.fromPartial(object.template.carousel),
            };
        }
        if (object.template?.$case === "slideshow" &&
            object.template?.slideshow !== undefined &&
            object.template?.slideshow !== null) {
            message.template = {
                $case: "slideshow",
                slideshow: composer_template_1.Slideshow.fromPartial(object.template.slideshow),
            };
        }
        if (object.template?.$case === "echoTall" &&
            object.template?.echoTall !== undefined &&
            object.template?.echoTall !== null) {
            message.template = {
                $case: "echoTall",
                echoTall: composer_template_1.EchoTall.fromPartial(object.template.echoTall),
            };
        }
        if (object.template?.$case === "echoWide" &&
            object.template?.echoWide !== undefined &&
            object.template?.echoWide !== null) {
            message.template = {
                $case: "echoWide",
                echoWide: composer_template_1.EchoWide.fromPartial(object.template.echoWide),
            };
        }
        if (object.template?.$case === "presetColor" &&
            object.template?.presetColor !== undefined &&
            object.template?.presetColor !== null) {
            message.template = {
                $case: "presetColor",
                presetColor: composer_template_1.PresetColor.fromPartial(object.template.presetColor),
            };
        }
        if (object.template?.$case === "whiteTall" &&
            object.template?.whiteTall !== undefined &&
            object.template?.whiteTall !== null) {
            message.template = {
                $case: "whiteTall",
                whiteTall: composer_template_1.WhiteTall.fromPartial(object.template.whiteTall),
            };
        }
        if (object.template?.$case === "whiteWide" &&
            object.template?.whiteWide !== undefined &&
            object.template?.whiteWide !== null) {
            message.template = {
                $case: "whiteWide",
                whiteWide: composer_template_1.WhiteWide.fromPartial(object.template.whiteWide),
            };
        }
        if (object.background?.$case === "colorBackground" &&
            object.background?.colorBackground !== undefined &&
            object.background?.colorBackground !== null) {
            message.background = {
                $case: "colorBackground",
                colorBackground: composer_background_1.ColorBackground.fromPartial(object.background.colorBackground),
            };
        }
        if (object.background?.$case === "echoBackground" &&
            object.background?.echoBackground !== undefined &&
            object.background?.echoBackground !== null) {
            message.background = {
                $case: "echoBackground",
                echoBackground: composer_background_1.EchoBackground.fromPartial(object.background.echoBackground),
            };
        }
        return message;
    },
};
//# sourceMappingURL=dpa_metadata.js.map